import * as eHubApi from "./data.service";

export function scan(req) {
  return eHubApi.post("/api/scanner/manifest/scan", req);
}

export function scanDelete(req) {
  return eHubApi.post("/api/scanner/manifest/scan/delete", req);
}

export function scanGet(req) {
  return eHubApi.post("/api/scanner/manifest/scan/get",req);
}

export function scanConfirm(req) {
    return eHubApi.post("/api/scanner/manifest/confirm",req);
  }

  export function getManifestNumberOptions() {
    return eHubApi.get("/api/report/manifest/options");
  }
